import { Box, Typography } from '@chronosphereio/chrono-ui';
import { NodeGraphPropsBase } from '@/core';
import { BasePanelProps } from '../../../plugin-system';
import { DependencyMap } from './DependencyMap';
import { useNodeGraphPanel } from './use-node-graph-panel';

export interface NodeGraphPanelProps extends BasePanelProps, NodeGraphPropsBase {}

export function NodeGraphPanel({ width, height, unit, thresholds, fromLabel, toLabel }: NodeGraphPanelProps) {
  const { links, selfLoops, error, config } = useNodeGraphPanel({ unit, thresholds, fromLabel, toLabel });

  if (width === undefined || height === undefined) return null;

  // Note: `height` only sizes this wrapper div. The graph itself sizes from a
  // resize-observed measurement inside `DependencyMapContent`, which keeps
  // the layout consistent across the dashboard cell and the (taller)
  // edit-modal preview without needing this prop.
  return (
    <Box style={{ width, height }} sx={{ flex: 1, display: 'flex', pt: 1, pb: 1.5 }}>
      {error === undefined ? (
        <DependencyMap links={links} selfLoops={selfLoops} config={config} />
      ) : (
        <Box
          sx={(theme) => ({
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: theme.spacing(2),
            textAlign: 'center',
          })}
        >
          <Typography variant="body2" color="text.secondary">
            {error}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
